import { types } from "../types/types";

const initialState = {
  logged: false,
  sessionId: null, // Agregar sessionId al estado inicial
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.login:
      return {
        ...state, // 👈 CONSERVA TODO
        logged: true,
        payload: action.payload,
        payloadMaster: null,
        sessionId: action.sessionId, // Guardar sessionId en el estado
      };
    case types.logout:
      return {
        logged: false,
        payload: null,
        payloadMaster: null,
        sessionId: null,
      };
    case types.switchToUser:
      return {
        ...state,
        payloadMaster: state.payload,
        payload: action.payload,
      };

  case types.restoreMaster:
  if (!state.payloadMaster) return state; // no cambia si no hay payloadMaster
  return {
    ...state,
    payload: state.payloadMaster,
    payloadMaster: null,
  };
    default:
      return state;
  }
};
